import logo from '../Images/logo preto.png';
import calender from '../Images/calendar.png';
import perfil from '../Images/psq.jpeg';
import sobre from '../Images/Sobre.jpeg';
import consultorio from '../Images/consultorio.jpeg';
import chat from '../Images/chat.png';
import world from '../Images/worldwide.png';
import medicine from '../Images/drugs.png';
import close from '../Images/close.png';
import stars from '../Images/stars.png';
import google from '../Images/google.png';
import whatsAppIcon from '../Images/whastapp.png';
import instagramImg from '../Images/instagram.png';
import wppFloat from '../Images/whatsappf.png';

import dependencias from '../Images/dependência.png';
import bipolar from '../Images/bipolar.png';
import depressao from '../Images/depressão.png';
import ansiedade from '../Images/ansiedade.png';
import toc from '../Images/toc.png';
import tdah from '../Images/tdah.png';
import audicao from '../Images/audicao.png';
import insonia from '../Images/insonia.png';
import fobias from '../Images/fobia.png';
import trauma from '../Images/tept.png';
import humor from '../Images/mudancas-de-humor.png';
import alimentar from '../Images/transtorno-alimentar.png';
import frustado from '../Images/frustrado.png';

export const SITE = {
  doctorName: 'Dr. Pedro Siqueira',
  specialtyLine: 'Médico | Saúde Mental | CRM 97044',
  doctoraliaUrl: 'https://www.doctoralia.com.br/pedro-henrique-siqueira-2',
  instagramUrl: 'https://www.instagram.com/siqueirapsiquiatria/',
  googleReviewUrl:
    'https://www.google.com/search?sca_esv=61711e8701c58ca5&rlz=1C1ONGR_enBR1145BR1145&sxsrf=AHTn8zrpqo4OHEJiQlzR42HlsrhRKW4PVA:1747931652819&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2Kzbe6LhHR2NGkg04A7FysV1mmtakplxfRnlWEsc-zfh5-_GZBqzCORtHt1DuzwTCRFQ0f09g0tHSe3GybazDyn8kDxx1XA4rNR_82SkxoQb-PKpEG_e07B1BgxEygo2c46G0iZSt5FQXn4dUNePeSlrqVD2CL2eKDZM9YoTIGFPnwNI9M9w%3D%3D&q=Dr.+Pedro+Siqueira+Psiquiatria+-+Belo+Horizonte+-+Presencial+e+Online+Coment%C3%A1rios&sa=X&ved=2ahUKEwj4-IbqwLeNAxWeIbkGHfwPOocQ0bkNegQIPBAE&cshid=1747931666739950&biw=1920&bih=945&dpr=1#lrd=0xa699a237f90def:0x8539f58ffdac3e7d,1,,,,',
  googleSearchUrl:
    'https://www.google.com/search?q=Dr.+Pedro+Siqueira+Psiquiatra+BH&sca_esv=61711e8701c58ca5&rlz=1C1ONGR_enBR1145BR1145&sxsrf=AHTn8zoXNaXeh-gdjWmmzE_1RHEnJnfF5g%3A1747931648336&ei=AFIvaPymFN6DhuMPi_KgoA8&ved=0ahUKEwj8pvbnwLeNAxXegWEGHQs5CPQQ4dUDCBA&uact=5&oq=Dr.+Pedro+Siqueira+Psiquiatra+BH&gs_lp=Egxnd3Mtd2l6LXNlcnAiIERyLiBQZWRybyBTaXF1ZWlyYSBQc2lxdWlhdHJhIEJIMgUQIRigATIFECEYoAFIgQ5Q0wJYogtwAHgAkAEAmAGkAaABjgSqAQMwLjS4AQPIAQD4AQGYAgSgApwEwgIHEAAYsAMYHsICCRAAGLADGAgYHsICCxAAGIAEGLADGKIEwgIIEAAYsAMY7wXCAgsQABiwAxiiBBiJBcICBhAAGBYYHsICCBAAGIAEGKIEwgIFEAAY7wXCAggQABiiBBiJBZgDAOIDBRIBMSBAiAYBkAYHkgcDMC40oAeIDrIHAzAuNLgHnAQ&sclient=gws-wiz-serp',
  phoneDisplay: '(31) 99505-4490',
  phoneWa: '5531995054490',
  address: 'Rua Montes Claros, 1201 - Carmo, Belo Horizonte - MG, 30310-702',
  whatsappPresetMessage:
    'Olá, Dr. Pedro!\n\nEncontrei seu site e me interessei pela consulta. Gostaria de saber como funciona o atendimento e quais são as opções disponíveis.\n\nObrigado(a)!',
  developerCredit: { label: 'Desenvolvido por Nathan Freitas', href: 'https://wa.me/31992239776' },
};

export const IMAGES = {
  logo,
  calender,
  perfil,
  sobre,
  consultorio,
  chat,
  world,
  medicine,
  close,
  stars,
  google,
  whatsAppIcon,
  instagramImg,
  wppFloat,
};

export const NAV_LINKS = [
  { href: '#inicio', label: 'Início' },
  { href: '#telemedicina', label: 'Atendimentos' },
  { href: '#sobre-mim', label: 'Sobre' },
  { href: '#consultorio', label: 'Consultório' },
  { href: '#saude-mental', label: 'Temas' },
  { href: '#depoimentos', label: 'Depoimentos' },
  { href: '#faq', label: 'FAQ' },
  { href: '#contato', label: 'Contato' },
];

export const intro = {
  badge: 'CRM 97044 · Belo Horizonte',
  doctorName: 'Dr. Pedro Siqueira',
  specialtyLine: 'Médico | Saúde Mental | CRM 97044',
  paragraph: (
    <>
      Sou médico formado pela <strong>Universidade Federal do Rio de Janeiro (UFRJ)</strong> com{' '}
      <strong>Honraria Acadêmica Cum Laude</strong> e faço parte da equipe médica de residência de psiquiatria do{' '}
      <strong>Hospital da Polícia Militar de Minas Gerais (HPM-MG)</strong>.
    </>
  ),
};

export const serviceCards = [
  {
    icon: chat,
    title: 'Consulta médica presencial',
    desc: 'Consulta médica com foco na escuta do paciente e tratamento. Duração média de 1 hora',
  },
  {
    icon: world,
    title: 'Teleconsulta: Brasil e exterior',
    desc: 'Possibilidade de ser atendido com qualidade via consulta online, sem precisar sair de casa para começar seu atendimento',
  },
  {
    icon: medicine,
    title: 'Tratamento e Acompanhamento',
    desc: 'Suporte contínuo para evolução e bem-estar ao longo do tratamento',
  },
];

export const heroIntro = {
  kicker: 'Atendimentos em Psiquiatria',
  text: (
    <>
      Cuidar da saúde mental é essencial para viver com mais equilíbrio e qualidade de vida. Isso ajuda a enfrentar desafios,
      fortalecer relacionamentos e promover o bem-estar —{' '}
      <strong>buscar apoio quando necessário é um ato de coragem.</strong>
    </>
  ),
};

export const about = {
  title: 'Sobre mim',
  body: (
    <>
      Sou médico formado com <strong>Honraria Acadêmica Cum Laude pela Universidade Federal do Rio de Janeiro (UFRJ)</strong> e
      tive a formação voltada a psiquiatria desde minha base, com passagem pelo{' '}
      <strong>Instituto de Psiquiatria da UFRJ (IPUB)</strong>, um dos mais renomados polos de formação da psiquiatria no Brasil.{' '}
      <br />
      <br />
      Faço parte da equipe médica de residência de psiquiatria do{' '}
      <strong>Hospital da Polícia Militar de Minas Gerais (HPM-MG)</strong>. Possuo experiências no cuidado médico nas mais diversas
      esferas, desde a atenção primária à saúde, pronto-atendimentos e instituições hospitalares.
      <br />
      <br />
      <strong>Será um prazer te ajudar da melhor forma possível, te ouvindo e buscando, junto a você, o melhor tratamento.</strong>
    </>
  ),
};

export const clinic = {
  title: 'Como será nosso atendimento?',
  body: (
    <>
      Nosso foco é a <strong>escuta do paciente</strong> para, com base em seu contexto e vivências, entender melhor sua realidade e
      construirmos juntos um caminho terapêutico. <br />
      <br />
      Cada consulta tem, em média, <strong>1 hora de duração, proporcionando um atendimento de qualidade</strong> com uma abordagem
      centrada no paciente. <br />
      <br />
      <strong>Oferecemos suporte contínuo por meio do WhatsApp e E-mail.</strong> <br />
      <br />
      Criamos um ambiente seguro e acolhedor, onde cada paciente é ouvido, compreendido e valorizado. Cuidamos de cada detalhe para
      garantir uma experiência positiva e confortável, pois acreditamos que um espaço aconchegante faz toda a diferença!
    </>
  ),
};

export const testimonialsIntro = {
  title: 'Depoimentos de Pacientes',
  blurb: (
    <>
      Convido você a conhecer as experiências de outros pacientes acessando{' '}
      <a href={SITE.doctoraliaUrl} className="text-primary font-semibold underline-offset-2 hover:underline" target="_blank" rel="noreferrer">
        meu perfil no <b>Doctoralia</b>
      </a>{' '}
      ou pelas{' '}
      <a href={SITE.googleSearchUrl} className="text-primary font-semibold underline-offset-2 hover:underline" target="_blank" rel="noreferrer">
        avaliações no <b>Google</b>
      </a>
      .
    </>
  ),
};

export const testimonialCards = [
  {
    id: 1,
    title: 'Carol',
    desc: 'Um excelente médico! Escuta com atenção e é muito atencioso. O tratamento que estou fazendo com ele está dando um ótimo resultado. Super indico!',
  },
  {
    id: 2,
    title: 'Maria',
    desc: 'Dr. Pedro é inteligente, atencioso e passa muita confiança. A estrutura do seu consultório é super aconchegante e a consulta flui com leveza. Recomendo muito!',
  },
  {
    id: 3,
    title: 'Luíza',
    desc: 'Um achado em BH. O dr. Pedro é um excelente médico, muito atencioso, sempre ouvindo seus pacientes com cuidado. Além disso, o consultório é bem localizado e é um ambiente agradável e acolhedor. Super índico!',
  },
  {
    id: 4,
    title: 'Giovana',
    desc: 'Sempre recomendo o dr. Pedro, pela confiança que tenho em seu trabalho. Profissional extremamente qualificado, ótimo ouvinte e muito atencioso.',
  },
  {
    id: 5,
    title: 'Ana',
    desc: 'Excelente profissional, extremamente humano e atencioso, explica todo o processo de forma clara e bastante acessível. Indiquei para meu familiares e todos tiveram a mesma percepção o que tem facilitado bastante o tratamento.',
  },
  {
    id: 6,
    title: 'Theodoro',
    desc: 'Dr Pedro e é um médico diferenciado. Sempre muito cuidadoso e profissional. Te ouve, te acolhe e te ajuda a enfrentar os seus problemas. Recomendo a todos.',
  },
  {
    id: 7,
    title: 'Rayssa',
    desc: 'médico diferenciado! recomendo demais! além do consultório ser extremamente confortável e de atmosfera relaxante, dr siqueira foi atencioso e didático demais. me ajuda até hoje!',
  },
  {
    id: 8,
    title: 'Vanessa',
    desc: 'Pedro é um profissional excelente!!! É muito confortante encontrar um profissional tão eficiente, que ama a profissão, atende de forma incrível, muito capacitado.',
  },
  {
    id: 9,
    title: 'Brenda',
    desc: 'Profissional excelente! Cuidadoso e competente. Recomendo de olhos fechados!',
  },
  {
    id: 10,
    title: 'Amanda',
    desc: 'Um ótimo médico! Precisava de uma consulta com uma certa urgência e consegui um bom horário. O atendimento foi humanizado e muito eficaz. Tem atenção e escuta o paciente. Super indico!',
  },
  {
    id: 11,
    title: 'Larissa',
    desc: 'Postura impecável, abordagem humanizada. O consultório é um espaço acolhedor e bem planejado, refletindo seu profissionalismo e cuidado com os pacientes.',
  },
];

export const topicCards = [
  {
    img: dependencias,
    title: 'Dependência de Substâncias',
    desc: 'Uso compulsivo de substâncias (álcool, drogas, medicamentos) que causa prejuízos físicos, psicológicos e sociais, além de sintomas de abstinência quando interrompido.',
  },
  {
    img: bipolar,
    title: 'Transtorno Bipolar',
    desc: 'Transtorno caracterizado por oscilações extremas de humor, indo de episódios depressivos a episódios de euforia',
  },
  {
    img: depressao,
    title: 'Depressão',
    desc: 'Transtorno caracterizado por tristeza persistente, perda de interesse em atividades, fadiga, alterações no sono e apetite, além de pensamentos negativos',
  },
  {
    img: ansiedade,
    title: 'Ansiedade',
    desc: 'Transtorno caracterizado por preocupação excessiva, tensão constante e sintomas físicos como palpitações e sudorese',
  },
  {
    img: toc,
    title: 'TOC (Transtorno Obsessivo-Compulsivo)',
    desc: 'Comportamentos compulsivos e pensamentos obsessivos que interferem na vida diária',
  },
  {
    img: tdah,
    title: 'TDAH (Déficit de Atenção e Hiperatividade)',
    desc: 'Desatenção, impulsividade e hiperatividade persistentes desde a infância',
  },
];

export const topicModalCategories = [
  {
    img: humor,
    title: 'Transtornos de Humor',
    items: ['Depressão', 'Transtorno afetivo bipolar'],
  },
  {
    img: audicao,
    title: 'Transtornos Psicóticos',
    items: ['Esquizofrenia', 'Transtornos Psicóticos'],
  },
  {
    img: alimentar,
    title: 'Transtornos Alimentares',
    items: ['Anorexia e Bulimia', 'Compulsão Alimentar'],
  },
  {
    img: insonia,
    title: 'Transtornos do Sono',
    items: ['Insônia'],
  },
  {
    img: frustado,
    title: 'Estresse Ocupacional',
    items: ['Síndrome de Burnout'],
  },
  {
    img: ansiedade,
    title: 'Transtornos de Ansiedade',
    items: ['Ansiedade', 'TAG (Ansiedade Generalizada)'],
  },
  {
    img: fobias,
    title: 'Transtornos Fóbicos',
    items: ['Fobias', 'Síndrome do Pânico'],
  },
  {
    img: trauma,
    title: 'Transtornos Relacionados ao Trauma',
    items: ['Transtorno de Estresse Pós-traumático (TEPT)', 'Trauma e Estresse'],
  },
];
